import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { TableRow, TableHead } from "@material-ui/core";

const styles = () => ({
  headerRow: {
    background: "#f9f9f9",
    height: "40px"
  }
});
const StyledTableHead = styled(TableHead)`
  && {
    border-bottom: 3px solid #eee;
  }
`;
const CashflowHeaderRow = ({ children, classes }) => (
  <StyledTableHead>
    <TableRow classes={{ root: classes.headerRow }}>
      {children}
    </TableRow>
  </StyledTableHead>
);
export default withStyles(styles)(CashflowHeaderRow);
